<a-center-popup [title]="'Stop Sprint'" (close)="onClose()">
  <p class="warning">Are you sure you want to STOP current Sprint?</p>
  <stop-sprint-form></stop-sprint-form>
</a-center-popup>
